import {
  EquityTransactionsRegister,
  type EquityTransactionRow,
} from '@/components/custom/companies/equity-transactions-register'
import { useCompanyTransactions } from '@/hooks/use-companies'

export function CompanyEquityTransactionsRegister({
  companyId,
}: {
  companyId: string
}) {
  const { data, isLoading } = useCompanyTransactions(companyId, {
    type: 'EQUITY_INVESTMENT',
  })

  const rows: EquityTransactionRow[] = (data?.data ?? []).map((t) => ({
    id: t.id,
    date: t.date,
    fundAbbreviation: t.fundAbbreviation,
    fundDisplayName: t.fundDisplayName,
    type: t.type,
    subType: t.subType ?? null,
    amount: t.amount,
  }))

  return <EquityTransactionsRegister rows={rows} isLoading={isLoading} />
}
